import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  useTheme,
  useMediaQuery,
  Button,
  TableCell,
  TableRow,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Checkbox,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import CircularProgress from "@mui/material/CircularProgress";
import {
  FIlterIcon,
  TrashIconForPopup,
  UpdateIcon,
} from "../../../assets/Icon/headerCicon";
import {
  DeleteIconTable,
  DownArrowIcon,
  SearchIcon,
} from "../../../assets/Icon/ArrowIcon";
import CloseIcon from "@mui/icons-material/Close";
import CustomTable from "../../common-components/CustomTable";
import Modal from "@mui/material/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import {
  ModalWrapper,
  CloseButton,
  CloseButtonWrapper,
} from "../../style/modalStyle";
import {
  CrossIcon,
  ModalBottom,
  ModalTop,
} from "../../../assets/Icon/ModalIcon";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useDispatch } from "react-redux";
import {
  deleteTransactions,
  getCategories,
  getTransactionsTableData,
  updateCategories,
} from "../../../stores/clients";
import { setToast } from "../../../stores/toast/toastslice";
import CommonPagination from "../../common-components/CommonPagination";
import { useSelector } from "react-redux";
dayjs.extend(customParseFormat);
dayjs.extend(utc);

const BookkeeperTable = ({
  title,
  value,
  isDelete,
  setData,
}: {
  title: string;
  value: number;
  isDelete: any;
  setData: (data: any) => void;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));

  const { data, total_records, error, clientListStatus } = useSelector(
    (state: any) => state.clients
  );

  //const [data, setData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [limit] = useState(10);
  const [deleting, setDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [appliedFilterValues, setAppliedFilterValues] = useState<number[]>([]);
  const [tempFilterValues, setTempFilterValues] = useState<number[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const searchDebounceRef = useRef<NodeJS.Timeout | null>(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [invoiceDateOpen, setInvoiceDateOpen] = React.useState(false);
  const [dueDateOpen, setDueDateOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openId, setOpenId] = useState<string | null>(null);

  const [categories, setCategories] = useState([]);
  const [categoryID, setCategoryID] = useState(0);
  const [transactionID, setTransactionID] = useState(0);
  const filterRef = useRef<HTMLDivElement>(null);
  const filterCategoryRef = useRef<HTMLDivElement>(null);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [openCategory, setOpenCategory] = useState<boolean>(false);
  const [openFilterCategory, setOpenFilterCategory] = useState<boolean>(false);
  const [categoryValue, setCategoryValue] = useState("");
  const [filterCategoryValue, setFilterCategoryValue] = useState("");
  const [pendingDeleteId, setPendingDeleteId] = useState<string | null>(null);
  const [openCategoryModal, setopenCategoryModal] = useState(false);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // ✅ Ignore clicks inside DatePicker popup
      if (target.closest(".MuiPickersPopper-root")) {
        return;
      }

      // ✅ Ignore clicks inside MUI Menu (Category dropdown)
      if (target.closest(".MuiPopover-root")) {
        return;
      }

      // ✅ Close only if click is outside the filter container
      if (filterRef.current && !filterRef.current.contains(target)) {
        setOpenFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const transcationData = async () => {
      //setSearchLoading(true);
      try {
        const response = await dispatch<any>(
          getTransactionsTableData({
            page: pageNo,
            limit: 10,
            transaction_type: value === 0 ? 2 : 1,
            filter_by_category: categoryID || 0,
            start_date: startDate?.toString() || "",
            end_date: endDate?.toString() || "",
            search: searchValue,
          })
        )
          .then((res: any) => {
            setData(res?.payload?.data?.summary);
          })
          .finally(() => {
            setTimeout(() => {
              //setSearchLoading(false);
            }, 2000);
          });
      } catch (error: any) {
        console.log(error.response?.data?.error || error.message);
      }
    };

    transcationData();
  }, [pageNo, value]);

  useEffect(() => {
    const categoriesData = async () => {
      try {
        setSearchLoading(true);
        const response = await dispatch<any>(
          getCategories(title === "Expenses" ? 1 : 0)
        )
          .then((res: any) => {
            setCategories(res?.payload?.data);
          })
          .finally(() => setSearchLoading(false));
      } catch (error: any) {
        console.log(error.response?.data?.error || error.message);
      }
    };

    categoriesData();
  }, [title]);

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setPendingDeleteId(null);
  };

  const handleDeleteConfirm = () => {
    setDeleting(true);
    setDeleteModalOpen(false);
    dispatch<any>(deleteTransactions(transactionID))
      .then((result: any) => {
        isDelete(true);
        dispatch<any>(
          setToast({
            message:
              result?.payload?.message || "Transaction deleted successully!",
            type: "success",
            title: "Success",
            onClose: () => {},
          })
        );
        dispatch<any>(
          getTransactionsTableData({
            page: pageNo,
            limit: 10,
            transaction_type: value === 0 ? 2 : 1,
            filter_by_category: categoryID,
            search: searchValue,
            start_date: startDate?.toString() || "",
            end_date: endDate?.toString() || "",
          })
        );
      })
      .finally(() => {
        setDeleting(false);
        isDelete(false);
      });
    setPendingDeleteId(null);
  };

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const search = e.target.value;
    setSearchValue(search);
    setSearchLoading(true);
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }
    searchDebounceRef.current = setTimeout(async () => {
      await dispatch<any>(
        getTransactionsTableData({
          page: pageNo,
          limit: 10,
          transaction_type: value === 0 ? 2 : 1,
          filter_by_category: 0,
          start_date: startDate?.toString() || "",
          end_date: endDate?.toString() || "",
          search: e.target.value,
        })
      )
        .then((res: any) => {
          // setData(res?.payload?.data?.transactions);
        })
        .finally(() => setSearchLoading(false));
    }, 1500);
  };

  const handleOpen = (event: React.MouseEvent<HTMLElement>, id: string) => {
    setAnchorEl(event.currentTarget);
    setOpenId(id);
    setOpenCategory(!openCategory);
  };

  const handlePageChange = (newPage: number) => {
    setPageNo(newPage);
  };

  return (
    <div>
      <div
        style={{
          display: isMobile ? "grid" : "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "white",
          padding: 20,
          marginTop: 0,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        <div
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          {title}
        </div>
        <div
          style={{
            display: isMobile ? "grid" : "flex",
            alignItems: "center",
            gap: 20,
          }}
        >
          <div
            style={{
              backgroundColor: "#F6F9FD",
              height: "40px",
              display: "flex",
              alignItems: "center",
              paddingLeft: 10,
              borderRadius: "8px",
              width: isMobile || isTablet ? "auto" : "318px",
              marginTop: isMobile ? 10 : 0,
              position: "relative",
            }}
          >
            <SearchIcon />
            <input
              style={{
                border: "none",
                backgroundColor: "transparent",
                padding: 3,
                outline: "none",
                paddingLeft: 10,
                width: "82%",
              }}
              value={searchValue}
              onChange={handleSearchInput}
              placeholder="Search here..."
            />
            {searchValue && (
              <CloseIcon
                onClick={() => {
                  setSearchValue("");
                  setSearchLoading(true);
                  dispatch<any>(
                    getTransactionsTableData({
                      page: pageNo,
                      limit: 10,
                      transaction_type: Number(value) === 0 ? 2 : 1,
                      filter_by_category: categoryID,
                      start_date: startDate?.toString() || "",
                      end_date: endDate?.toString() || "",
                      search: "",
                    })
                  ).finally(() => setSearchLoading(false));
                }}
                style={{
                  position: "absolute",
                  right: 8,
                  cursor: "pointer",
                  color: "#97999B",
                  fontSize: 20,
                }}
              />
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <div ref={filterRef} style={{ position: "relative" }}>
              {/* Red dot indicator when filter is applied */}
              {isFilterApplied && (
                <span
                  style={{
                    position: "absolute",
                    top: 8,
                    left: 8,
                    width: 10,
                    height: 10,
                    background: "#F44336",
                    borderRadius: "50%",
                    zIndex: 2,
                    border: "2px solid #fff",
                  }}
                />
              )}
              <Button
                style={{
                  border: "1px solid #EAF1FA",
                  borderRadius: "8px",
                  height: "40px",
                  padding: 15,
                  color: "#6C6F71",
                  fontSize: "12px",
                  fontWeight: 600,
                  gap: 10,
                }}
                onClick={() => {
                  setTempFilterValues(appliedFilterValues);
                  setOpenFilter(!openFilter);
                }}
              >
                <FIlterIcon />
                Filter
              </Button>

              {openFilter && (
                <div
                  style={{
                    position: "absolute",
                    marginTop: 10,
                    backgroundColor: "white",
                    borderRadius: "8px",
                    width: isMobile ? "240px" : "400px",
                    right: isMobile ? "" : "0px",
                    zIndex: 1000,
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                    marginBottom: 20,
                  }}
                >
                  <div>
                    <p
                      style={{
                        padding: 10,
                        paddingTop: 16,
                        paddingLeft: 16,
                        borderBottom: "1px solid #EDF2F6",
                        color: "#01060B",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Filter
                    </p>
                    <Formik
                      initialValues={{ invoiceDate: "", dueDate: "" }}
                      onSubmit={() => {}}
                      validateOnChange={true}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        isSubmitting,
                        handleSubmit,
                        setFieldValue,
                      }) => (
                        <div style={{ padding: "10px 20px" }}>
                          {/**Dates */}
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="en-gb"
                          >
                            <Box
                              sx={{
                                display: isMobile ? "grid" : "flex",
                                justifyContent: "space-between",
                                gap: 2,
                              }}
                            >
                              {/* Invoice Date */}
                              <div>
                                <label
                                  style={{
                                    fontWeight: 500,
                                    color: "#2C3034",
                                    fontSize: "16px",
                                    marginBottom: 5,
                                    display: "block",
                                  }}
                                >
                                  Start date
                                </label>
                                <DatePicker
                                  format="DD/MM/YYYY"
                                  value={startDate}
                                  maxDate={dayjs().startOf("day")} // ⬅ Disable future dates
                                  //minDate={dayjs().startOf("day")}
                                  onChange={(val) => {
                                    setFieldValue(
                                      "invoiceDate",
                                      val
                                        ? dayjs.utc(val.format("YYYY-MM-DD"))
                                        : null
                                    );
                                    if (val) {
                                      setStartDate(
                                        dayjs.utc(val.format("YYYY-MM-DD"))
                                      );
                                    }
                                  }}
                                  open={invoiceDateOpen}
                                  onOpen={() => setInvoiceDateOpen(true)}
                                  onClose={() => setInvoiceDateOpen(false)}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "medium",
                                      sx: {
                                        flex: 1,
                                        width: "172px",
                                        boxShadow: "0px 2px 4px 0px #D1DEEB33",
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            border: "0.5px solid #EAF1FA",
                                            borderRadius: "8px",
                                          },
                                          "&:hover fieldset": {
                                            border: "0.5px solid #EAF1FA",
                                            borderRadius: "8px",
                                          },
                                          "&.Mui-focused fieldset": {
                                            border: "0.5px solid #2977CC",
                                          },
                                        },
                                      },
                                      onClick: () => setInvoiceDateOpen(true),
                                    },
                                  }}
                                />
                                {/* {touched.invoiceDate && errors.invoiceDate && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "16px",
                                  marginTop: "4px",
                                  marginLeft: "4px",
                                }}
                              >
                                {errors.invoiceDate}
                              </div>
                            )} */}
                              </div>

                              {/* Due Date */}
                              <div>
                                <label
                                  style={{
                                    fontWeight: 500,
                                    color: "#2C3034",
                                    fontSize: "16px",
                                    marginBottom: 5,
                                    display: "block",
                                  }}
                                >
                                  End date
                                </label>
                                <DatePicker
                                  format="DD/MM/YYYY"
                                  value={endDate}
                                  // minDate={
                                  //   values.invoiceDate
                                  //     ? values.invoiceDate
                                  //     : dayjs().startOf("day")
                                  // }
                                  maxDate={dayjs().startOf("day")} // ⬅ Disable future dates
                                  onChange={(val) => {
                                    setFieldValue(
                                      "dueData",
                                      val
                                        ? dayjs.utc(val.format("YYYY-MM-DD"))
                                        : null
                                    );
                                    if (val) {
                                      setEndDate(
                                        dayjs.utc(val.format("YYYY-MM-DD"))
                                      );
                                    }
                                  }}
                                  open={dueDateOpen}
                                  onOpen={() => setDueDateOpen(true)}
                                  onClose={() => setDueDateOpen(false)}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "medium",
                                      sx: {
                                        flex: 1,
                                        width: "172px",
                                        boxShadow: "0px 2px 4px 0px #D1DEEB33",
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            border: "0.5px solid #EAF1FA",
                                            borderRadius: "8px",
                                          },
                                          "&:hover fieldset": {
                                            border: "0.5px solid #EAF1FA",
                                            borderRadius: "8px",
                                          },
                                          "&.Mui-focused fieldset": {
                                            border: "0.5px solid #2977CC",
                                          },
                                        },
                                      },
                                      inputProps: { readOnly: true },
                                      onClick: () => setDueDateOpen(true),
                                    },
                                  }}
                                />
                                {touched.dueDate && errors.dueDate && (
                                  <div
                                    style={{
                                      color: "red",
                                      fontSize: "16px",
                                      marginTop: "4px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    {errors.dueDate}
                                  </div>
                                )}
                              </div>
                            </Box>
                          </LocalizationProvider>

                          {/**Category filter */}
                          <div
                            ref={filterCategoryRef}
                            style={{ position: "relative" }}
                          >
                            <div
                              style={{
                                fontWeight: 500,
                                color: "#2C3034",
                                fontSize: "16px",
                                marginBottom: 5,
                                display: "block",
                                marginTop: 14,
                              }}
                            >
                              Category
                            </div>
                            {/* Red dot indicator when filter is applied */}
                            <Button
                              style={{
                                border: "0.5px solid #EAF1FA",
                                borderRadius: "8px",
                                height: "40px",
                                padding: 15,
                                color: "#97999B",
                                fontSize: "16px",
                                fontWeight: 500,
                                width: "100%",
                              }}
                              onClick={() => {
                                setOpenFilterCategory(!openFilterCategory);
                              }}
                            >
                              {filterCategoryValue?.length ? (
                                <p
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                    color: "black",
                                    fontWeight: 400,
                                  }}
                                >
                                  {filterCategoryValue?.length > 30
                                    ? `${filterCategoryValue?.slice(0, 30)}...`
                                    : filterCategoryValue}
                                  <DownArrowIcon />
                                </p>
                              ) : (
                                <p
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  {" "}
                                  Select Category
                                  <DownArrowIcon />
                                </p>
                              )}
                            </Button>
                            {openFilterCategory && (
                              <div
                                style={{
                                  position: "absolute",
                                  marginTop: 10,
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                  width: "480px",
                                  right: isMobile ? "" : "0px",
                                  zIndex: 1000,
                                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                                  marginBottom: 20,
                                }}
                              >
                                {openFilterCategory && (
                                  <Menu
                                    open={openFilterCategory}
                                    anchorEl={filterCategoryRef.current}
                                    onClose={() => setOpenFilterCategory(false)}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "right",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "right",
                                    }}
                                    PaperProps={{
                                      style: {
                                        height:
                                          categories?.length > 1 ? "160px" : "",
                                        borderRadius: "8px",
                                        marginTop: 10,
                                        width: "400px",
                                        boxShadow:
                                          "0px 2px 4px rgba(0, 0, 0, 0.2)",
                                      },
                                    }}
                                  >
                                    {categories?.map((item: any, idx) => (
                                      <MenuItem
                                        key={item?.id}
                                        onClick={() => {
                                          console.log("Filter by year:", item);
                                          setOpenFilterCategory(false);
                                          setFilterCategoryValue(item?.name);
                                          setCategoryID(item?.id);
                                        }}
                                        sx={{
                                          borderRadius: "6px",
                                          "&:hover": {
                                            backgroundColor: "#A7C7EA66", // light blue hover
                                            color: "#1D538F",
                                            borderRadius: 0,
                                          },
                                          borderBottom:
                                            idx <= categories?.length - 2
                                              ? "1px solid #EDF2F6"
                                              : "",
                                          color: "#6C6F71",
                                          fontWeight: 500,
                                          fontSize: "16px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "100%",
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                          }}
                                        >
                                          {item?.name?.length > 40
                                            ? `${item?.name?.slice(0, 40)}...`
                                            : item?.name}
                                        </div>
                                      </MenuItem>
                                    ))}
                                  </Menu>
                                )}
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              marginTop: 20,
                              display: isMobile ? "grid" : "flex",
                              alignItems: "center",
                              justifyContent: isMobile ? "center" : "",
                              gap: 20,
                            }}
                          >
                            <Button
                              disabled={
                                !(
                                  (dayjs(startDate).isValid() &&
                                    dayjs(endDate).isValid()) ||
                                  filterCategoryValue?.length
                                )
                              }
                              type="submit"
                              sx={{
                                width: "130px",
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#fff",
                                height: "36px",
                                background: !(
                                  (dayjs(startDate).isValid() &&
                                    dayjs(endDate).isValid()) ||
                                  filterCategoryValue?.length
                                )
                                  ? "#BDBDBD"
                                  : "linear-gradient(to right, #2977CC, #1D538F)",
                                cursor: !(
                                  (dayjs(startDate).isValid() &&
                                    dayjs(endDate).isValid()) ||
                                  filterCategoryValue?.length
                                )
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: !(
                                  (dayjs(startDate).isValid() &&
                                    dayjs(endDate).isValid()) ||
                                  filterCategoryValue?.length
                                )
                                  ? 0.7
                                  : 1,
                              }}
                              onClick={async () => {
                                setFilterLoading(true);
                                setAppliedFilterValues(tempFilterValues);
                                setOpenFilter(false);
                                await dispatch<any>(
                                  getTransactionsTableData({
                                    page: pageNo,
                                    limit: 10,
                                    transaction_type: value === 0 ? 2 : 1,
                                    search: searchValue,
                                    filter_by_category: categoryID,
                                    start_date: startDate?.toString() || "",
                                    end_date: endDate?.toString() || "",
                                  })
                                )
                                  .then((res: any) => {
                                    setData(res?.payload?.data?.summary);
                                    setIsFilterApplied(true);
                                    console.log("Filtered data:", res);
                                  })
                                  .finally(() => setFilterLoading(false));
                              }}
                            >
                              Apply
                            </Button>
                            <button
                              disabled={
                                !(
                                  (dayjs(startDate).isValid() &&
                                    dayjs(endDate).isValid()) ||
                                  filterCategoryValue?.length
                                )
                              }
                              style={{
                                textAlign: "center",
                                border: "none",
                                fontSize: "14px",
                                fontWeight: 600,
                                background:
                                  "linear-gradient(to right, #2977CC, #1D538F)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                cursor: !(
                                  (dayjs(startDate).isValid() &&
                                    dayjs(endDate).isValid()) ||
                                  filterCategoryValue?.length
                                )
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: !(
                                  (dayjs(startDate).isValid() &&
                                    dayjs(endDate).isValid()) ||
                                  filterCategoryValue?.length
                                )
                                  ? 0.5
                                  : 1,
                              }}
                              onClick={() => {
                                setFilterLoading(true);
                                setFilterCategoryValue("");
                                setStartDate(null);
                                setEndDate(null);
                                dispatch<any>(
                                  getTransactionsTableData({
                                    page: pageNo,
                                    limit: 10,
                                    transaction_type: value === 0 ? 2 : 1,
                                    filter_by_category: 0,
                                    search: "",
                                    start_date: "",
                                    end_date: "",
                                  })
                                )
                                  .then((res: any) => {
                                    setData(res?.payload?.data?.summary);
                                    setIsFilterApplied(false);
                                  })
                                  .finally(() => setFilterLoading(false));
                                setOpenFilter(false);
                              }}
                            >
                              Reset filter
                            </button>
                          </div>
                        </div>
                      )}
                    </Formik>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/**TABLE */}
      <div>
        <CustomTable
          headings={[
            "SR. NO",
            "Date",
            "Bank",
            "Account",
            "Description",
            "Amount",
            "CAtegory",
            "Action",
          ]}
        >
          {filterLoading || searchLoading || clientListStatus === "loading" ? (
            <TableRow>
              <TableCell colSpan={7} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : (
            data &&
            data?.transactions?.map((item: any, idx: number) => (
              <TableRow key={item?.id}>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {(pageNo - 1) * limit + idx + 1}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  <span>
                    {new Date(item?.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </span>
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.bank_name || "-"}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.account_name}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.name}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.amount < 0
                    ? `-$${item?.amount?.toString()?.replace("-", "")}`
                    : `$${item?.amount}`}
                </TableCell>
                <TableCell
                  key={item.id}
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  <div style={{ position: "relative" }}>
                    {/* Red dot indicator when filter is applied */}
                    <Button
                      style={{
                        border: "1px solid #A7C7EA",
                        borderRadius: "8px",
                        height: "40px",
                        padding: 15,
                        color: "#97999B",
                        fontSize: "16px",
                        fontWeight: 500,
                        gap: 10,
                        width: "180px",
                        position: "relative",
                      }}
                      onClick={(e) => {
                        handleOpen(e, item?.id);
                      }}
                    >
                      {item?.updated_category_name ? (
                        <p
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          {" "}
                          <p>
                            {" "}
                            {item?.updated_category_name?.length > 14
                              ? `${item?.updated_category_name?.slice(
                                  0,
                                  14
                                )}...`
                              : item?.updated_category_name}
                          </p>
                          <DownArrowIcon />
                        </p>
                      ) : (
                        <p
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          {" "}
                          Select Category
                          <DownArrowIcon />
                        </p>
                      )}
                    </Button>
                    {openCategory && (
                      <div
                        style={{
                          position: "absolute",
                          marginTop: 10,
                          backgroundColor: "white",
                          borderRadius: "8px",
                          width: "480px",
                          right: isMobile ? "" : "0px",
                          zIndex: 1000,
                          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        {openCategory && (
                          <Menu
                            open={Boolean(anchorEl) && openId === item.id}
                            anchorEl={anchorEl}
                            onClose={() => setOpenCategory(false)}
                            PaperProps={{
                              style: {
                                borderRadius: "8px",
                                marginTop: 10,
                                width: "400px",
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                                height: categories?.length > 1 ? "150px" : "",
                              },
                            }}
                          >
                            {categories?.map((category: any, idx) => (
                              <MenuItem
                                key={idx}
                                onClick={() => {
                                  console.log("Filter by year:", category);
                                  setOpenCategory(false);
                                  setCategoryID(category?.id);
                                  setTransactionID(item?.id);
                                  setCategoryValue(category?.name);
                                  setopenCategoryModal(true);
                                }}
                                sx={{
                                  borderRadius: "6px",
                                  "&:hover": {
                                    backgroundColor: "#A7C7EA66", // light blue hover
                                    color: "#1D538F",
                                    borderRadius: 0,
                                  },
                                  color: "#6C6F71",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                  }}
                                >
                                  {category?.name?.length > 40
                                    ? `${category?.name?.slice(0, 40)}...`
                                    : category?.name}
                                </div>
                              </MenuItem>
                            ))}
                          </Menu>
                        )}
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    paddingLeft: 40,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setTransactionID(item?.id);
                    setDeleteModalOpen(true);
                  }}
                >
                  <DeleteIconTable />
                </TableCell>
              </TableRow>
            ))
          )}
        </CustomTable>
        {data?.transactions?.length === 0 &&
          !filterLoading &&
          !searchLoading && (
            <div
              style={{
                textAlign: "center",
                marginTop: 20,
              }}
            >
              No transactions found!
            </div>
          )}
        {/* Pagination */}
        {Math.ceil(total_records / limit) > 1 && (
          <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
            <CommonPagination
              currentPage={pageNo}
              totalPages={Math.ceil(total_records / limit)}
              onPageChange={handlePageChange}
            />
          </Box>
        )}
      </div>
      <Modal open={deleteModalOpen} onClose={handleDeleteCancel}>
        <ModalWrapper
          sx={{
            width: isMobile ? "350px" : "500px",
            p: 0,
            height: "370px",
            backgroundImage: "none",
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            outline: "none",
          }}
        >
          {/* Top right decoration */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <ModalTop />
          </div>
          {/* Bottom left decoration */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              left: 0,
              zIndex: 1,
            }}
          >
            <ModalBottom />
          </div>
          {/* Ensure close button is above decorations */}
          <CloseButtonWrapper
            sx={{ zIndex: 10, position: "relative", marginTop: 1 }}
          >
            <CloseButton onClick={handleDeleteCancel}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Box sx={{ p: 4, pt: 0 }}>
            {/* Trash icon with red bg */}
            <Box
              sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}
            >
              <Box
                sx={{
                  background: "#F20F0014",
                  borderRadius: "50%",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TrashIconForPopup />
              </Box>
            </Box>
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? "20px" : "24px",
                color: "#01060B",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: 10,
              }}
            >
              Delete Expenses
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "250px",
                textAlign: "center",
                lineHeight: "24px",
                margin: "0 auto",
                fontSize: isMobile ? "12px" : "16px",
                color: "#6C6F71",
                fontWeight: 500,
                fontFamily: "Plus Jakarta Sans",
              }}
            >
              Are you sure you want to delete this expenses?
            </div>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 3,
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  border: "2px solid #2977CC",
                  borderRadius: "8px",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#2977CC",
                }}
                onClick={handleDeleteCancel}
              >
                Close
              </Button>
              <Button
                sx={{
                  background: "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
                onClick={handleDeleteConfirm}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </ModalWrapper>
      </Modal>
      {/**Update category */}
      <Modal
        open={openCategoryModal}
        onClose={() => {
          setCategoryValue("");
          setopenCategoryModal(false);
        }}
      >
        <ModalWrapper
          sx={{
            width: isMobile ? "350px" : "500px",
            p: 0,
            height: "370px",
            backgroundImage: "none",
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            outline: "none",
          }}
        >
          {/* Top right decoration */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <ModalTop />
          </div>
          {/* Bottom left decoration */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              left: 0,
              zIndex: 1,
            }}
          >
            <ModalBottom />
          </div>
          {/* Ensure close button is above decorations */}
          <CloseButtonWrapper
            sx={{ zIndex: 10, position: "relative", marginTop: 1 }}
          >
            <CloseButton onClick={() => setopenCategoryModal(false)}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Box sx={{ p: 4, pt: 0 }}>
            {/* Trash icon with red bg */}
            <Box
              sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}
            >
              <Box
                sx={{
                  background: "#2977CC36",
                  borderRadius: "50%",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <UpdateIcon />
              </Box>
            </Box>
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? "20px" : "24px",
                color: "#01060B",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: 10,
              }}
            >
              Update Category
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "250px",
                textAlign: "center",
                lineHeight: "24px",
                margin: "0 auto",
                fontSize: isMobile ? "12px" : "16px",
                color: "#6C6F71",
                fontWeight: 500,
                fontFamily: "Plus Jakarta Sans",
              }}
            >
              Are you sure you want to update the category?
            </div>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 3,
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  border: "2px solid #2977CC",
                  borderRadius: "8px",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#2977CC",
                }}
                onClick={() => {
                  setCategoryValue("");
                  setopenCategoryModal(false);
                }}
              >
                Close
              </Button>
              <Button
                sx={{
                  background: "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
                onClick={async () => {
                  setFilterLoading(true);
                  setopenCategoryModal(false);
                  await dispatch<any>(
                    updateCategories({
                      transaction_id: transactionID,
                      category_id: categoryID,
                    })
                  ).then((result: any) => {
                    dispatch<any>(
                      setToast({
                        message:
                          result?.payload?.message ||
                          "Transaction category updated successfully!",
                        type: "success",
                        title: "Success",
                        onClose: () => {},
                      })
                    );
                    dispatch<any>(
                      getTransactionsTableData({
                        page: pageNo,
                        limit: 10,
                        transaction_type: value === 0 ? 2 : 1,
                        filter_by_category: 0,
                        search: searchValue,
                        start_date: startDate?.toString() || "",
                        end_date: endDate?.toString() || "",
                      })
                    ).finally(() => setFilterLoading(false));
                  });
                }}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </ModalWrapper>
      </Modal>
    </div>
  );
};

export default BookkeeperTable;
